import { NgModule, DoBootstrap, ApplicationRef } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { setAngularJSGlobal, UpgradeModule } from '@angular/upgrade/static';
import * as angular from 'angular';

import { GoModulesModule } from '@go-modules/go-modules.module';
import { InterceptorsModule } from '@go-modules/services/interceptors';
import { DashboardModule } from '@go-modules/components/dashboard/dashboard.module';

import { SuperBarModule } from '@dashboard/app/components/super-bar/super-bar.module';
import { NgxFoldersViewModule } from '@dashboard/app/components/folders-view/folders-view.module';
import { SignupModule } from '@dashboard/app/components/signup/signup.module';
import { DashboardTranslateLoader } from './translate-loader';
import { AppComponent } from './app.component';
import { LegacyRootUpgradeDirective } from './legacy/legacy-root.upgrade';
import { dashboardLegacyModule } from './legacy/dashboard-legacy.module';
import { PWAInstallPromptModule } from '@dashboard/app/components/pwa-install-prompt/pwa-install-prompt.module';

@NgModule({
	declarations: [
		AppComponent,
		LegacyRootUpgradeDirective
	],
	imports: [
		BrowserModule,
		HttpClientModule,
		UpgradeModule,
		TranslateModule.forRoot({
			defaultLanguage: 'en',
			loader: {
				provide: TranslateLoader,
				useFactory: DashboardTranslateLoader.factory,
				deps: [HttpClient]
			}
		}),
		GoModulesModule, // This needs to slowly be replaced by real components modules depending on correct things
		InterceptorsModule,
		BrowserAnimationsModule,
		DashboardModule,
		NgxFoldersViewModule,
		SignupModule,
		SuperBarModule,
		PWAInstallPromptModule
	],
	providers: [
		{ provide: '$scope', useExisting: '$rootScope' }
	]
})
export class AppModule implements DoBootstrap {
	constructor (private upgrade: UpgradeModule) { }

	public ngDoBootstrap (app: ApplicationRef): void {
		setAngularJSGlobal(angular);
		this.upgrade.bootstrap(document.body, [
			dashboardLegacyModule
		]);
		app.bootstrap(AppComponent);
	}
}
